module.exports = __webpack_public_path__ + "media/images/flags/jp-e1b1759ccf64e586f9fcbad7c095671c.svg";